import { createReducer, on } from '@ngrx/store';

import {
    IGamificacionAutoevaluacion,
    IGamificacionCuotas,
    IGamificacionResumen,
    ProgramaCDGTenderos,
} from '../../shared/models/ProgramaCDGTenderos.interface';
import {
    clearGamificacion,
    completeLoadingProgram,
    errorGetAverageTicketCDG,
    errorGetCDGProgam,
    errorGetGamificacionAutoevaluacion,
    errorGetGamificacionCuotas,
    errorGetGamificacionResumen,
    getAverageTicketCDG,
    getGamificacionAutoevaluacion,
    getGamificacionCuotas,
    getGamificacionResumen,
    getPointsStorageCDG,
    getProgamCDG,
    setPointsStorageCDG,
    successGetAverageTicketCDG,
    successGetCDGProgam,
    successGetGamificacionAutoevaluacion,
    successGetGamificacionCuotas,
    successGetGamificacionResumen,
} from '../actions/cdg-program.actions';

export interface CDGProgramState {
    loadingProgram: boolean;
    loadingPoints: boolean;
    program: {
        data: ProgramaCDGTenderos[];
        api: string;
        success: boolean;
        failed: boolean;
        error: Error | null;
    };
    averageTicket: {
        data: { averageTicket: number; };
        programData: ProgramaCDGTenderos[];
        success: boolean;
        failed: boolean;
        error: Error | null;
    };
    points: {
        data: {
            points: number;
            lastDate: string;
        }
        api: string;
        success: boolean;
        failed: boolean;
        error: Error | null;
    }
}

export const CGPProgramInitState: CDGProgramState = {
    loadingProgram: false,
    loadingPoints: false,
    program: {
        data: [],
        api: '',
        success: false,
        failed: false,
        error: null
    },
    averageTicket: {
        data: { averageTicket: 0 },
        programData: [],
        success: false,
        failed: false,
        error: null
    },
    points: {
        data: { points: 0, lastDate: '' },
        api: '',
        success: false,
        failed: false,
        error: null
    }
}

const _CDGProgramReducer = createReducer(
    CGPProgramInitState,
    on(getProgamCDG, (state, { api }) => (
        {
            ...state,
            loadingProgram: true,
            program: {
                ...state.program,
                api,
                success: false,
                failed: false
            }
        }
    )),
    on(successGetCDGProgam, (state, { data }) => (
        {
            ...state,
            program: {
                ...state.program,
                success: true,
                failed: false,
                data
            }
        }
    )),
    on(errorGetCDGProgam, (state, { payload }) => (
        {
            ...state,
            loadingProgram: false,
            program: {
                ...state.program,
                success: false,
                failed: true,
                error: { ...payload }
            }
        }
    )),
    on(completeLoadingProgram, (state) => (
        {
            ...state,
            loadingProgram: false
        }
    )),
    on(getAverageTicketCDG, (state, { programData }) => (
        {
            ...state,
            averageTicket: {
                ...state.averageTicket,
                programData,
                success: false,
                failed: false
            }
        }
    )),
    on(successGetAverageTicketCDG, (state, { data }) => (
        {
            ...state,
            loadingProgram: false,
            averageTicket: {
                ...state.averageTicket,
                success: true,
                failed: false,
                data
            }
        }
    )),
    on(errorGetAverageTicketCDG, (state, { payload }) => (
        {
            ...state,
            loadingProgram: false,
            averageTicket: {
                ...state.averageTicket,
                success: false,
                failed: true,
                error: { ...payload }
            }
        }
    )),
    on(getPointsStorageCDG, state => (
        {
            ...state,
            loadingPoints: false,
            points: {
                ...state.points,
                success: false,
                failed: false
            }
        }
    )),
    on(setPointsStorageCDG, (state, { points, lastDate }) => (
        {
            ...state,
            loadingPoints: false,
            points: {
                ...state.points,
                data: {
                    points,
                    lastDate
                },
                success: true,
                failed: false
            }
        }
    ))
)

export function CDGProgramReducer(state: any, action: any) {
    return _CDGProgramReducer(state, action);
}

/**
 * * Consulta de resumen dashboard
 */
interface GenericResp {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
}
export interface IResumenG extends GenericResp {
    data: IGamificacionResumen;
}
export interface IAutoevaluacionG extends GenericResp {
    data: IGamificacionAutoevaluacion;
}
export interface ICuotasG extends GenericResp {
    data: IGamificacionCuotas;
}
export interface GamificacionState {
    Resumen: IResumenG;
    Autoevaluacion: IAutoevaluacionG;
    Cuotas: ICuotasG;
}

export const GamificacionInit: GamificacionState = {
    Resumen: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        data: {} as IGamificacionResumen,
    },
    Autoevaluacion: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        data: {} as IGamificacionAutoevaluacion,
    },
    Cuotas: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        data: {} as IGamificacionCuotas,
    },
};

const _gamificacionReducer = createReducer(
    GamificacionInit,
    on(getGamificacionResumen, state => (
        {
            ...state,
            Resumen: {
                ...state.Resumen,
                loading: true,
                success: false,
                failed: false,
            }
        }
    )),
    on(successGetGamificacionResumen, (state, { data }) => (
        {
            ...state,
            Resumen: {
                ...state.Resumen,
                loading: false,
                success: true,
                data,
            }
        }
    )),
    on(errorGetGamificacionResumen, (state, { payload }) => (
        {
            ...state,
            Resumen: {
                ...state.Resumen,
                loading: false,
                failed: true,
                error: payload,
            }
        }
    )),
    on(clearGamificacion, state => ({ ...state, ...GamificacionInit })),
    on(getGamificacionAutoevaluacion, state => (
        {
            ...state,
            Autoevaluacion: {
                ...state.Autoevaluacion,
                loading: true,
                success: false,
                failed: false,
            }
        }
    )),
    on(successGetGamificacionAutoevaluacion, (state, { data }) => (
        {
            ...state,
            Autoevaluacion: {
                ...state.Autoevaluacion,
                loading: false,
                success: true,
                data: Object.keys(data).length > 0 ? data : { ...state.Autoevaluacion.data, CHECK_FINE_COMPLETO: 0, DIAS_PENDIENTES_POR_CERRAR: 0 },
            }
        }
    )),
    on(errorGetGamificacionAutoevaluacion, (state, { payload }) => (
        {
            ...state,
            Autoevaluacion: {
                ...state.Autoevaluacion,
                loading: false,
                failed: true,
                error: payload,
            }
        }
    )),
    on(getGamificacionCuotas, state => (
        {
            ...state,
            Cuotas: {
                ...state.Cuotas,
                loading: true,
                success: false,
                failed: false,
            }
        }
    )),
    on(successGetGamificacionCuotas, (state, { data }) => (
        {
            ...state,
            Cuotas: {
                ...state.Cuotas,
                loading: false,
                success: true,
                data: Object.keys(data).length > 0 ? data : { ...state.Cuotas.data, CHECK_FINE: 0, DIAS_POR_CUMPLIR: 0 },
            }
        }
    )),
    on(errorGetGamificacionCuotas, (state, { payload }) => (
        {
            ...state,
            Cuotas: {
                ...state.Cuotas,
                loading: false,
                failed: true,
                error: payload,
            }
        }
    )),
);

export function GamificacionReducer(state: any, action: any) {
    return _gamificacionReducer(state, action);
}
